import Food from './plate.png';
import Drink from './drink.png';
import Dessert from './icecream.png';

export default {
  Food,
  Drink,
  Dessert
};
